module.exports = __webpack_public_path__ + "img/logo1.003a8884.png";